<template>
  <PageLayout>
    <PageHeader
      :title="$t(`Common.title.homeTitle`)"
      :breadcrumb="[
        {
          title: `${$t('Common.title.homeTitle')}`,
        },
        {
          title: `${this.$t(`Common.title.search`)}`,
        },
      ]"
    />
    <m-form ref="form" class="pt-4">
      <!-- 基本信息 -->
      <template>
        <m-folding-panel
          :title="$t(`apply.title.applyInfo`)"
          enableCollapsed
          :active="true"
          :class="`rainbow__folding__panel rainbow__page0 pl-4 pr-4 pb-8`"
        >
          <div
            v-if="form.status === 'REMODIFY'"
            class="mb-4"
            style="
              background-color: #fef5d1;
              flex-direction: row;
              display: flex;
              align-content: center;
              justify-items: center;
              color: #717170;
            "
          >
            <ExclamationCircleFilled
              class="pa-4"
              style="
                align-content: center;
                justify-items: center;
                color: #ffc441;
              "
            />
            <span class="mb-4 mt-4 ml-2 mr-2" style="text-align: justify;">
              {{ $t(`apply.title.remoifyTip`) }}
            </span>
          </div>
          <div
            :style="{
              'flex-direction': is_mobile() ? 'column' : 'row',
              display: 'flex',
            }"
          >
            <m-cell>
              <m-cell-item
                :label="$t('apply.title.applyType')"
                :value="form.applicationType ? this.$t(`apply.title.${form.applicationType}`) : ''"
              ></m-cell-item>
              <m-cell-item
                :label="$t('apply.title.companyType')"
                :value="getCompanyType(form.companyType)"
              ></m-cell-item>
              <m-cell-item
                :label="$t('apply.title.applyCaseNo')"
                :value="form.applicationNo"
              ></m-cell-item>
              <m-cell-item
                :label="$t('apply.title.approvalStatus')"
                :value="
                  form.status ? `${this.$t(`statusType.${form.status}`)}` : ''
                "
              ></m-cell-item>
              <m-cell-item
                v-if="form.status === 'NO_PASSED'"
                :label="$t('apply.title.noPassedReason')"
                :value="form.noPassedReason"
              ></m-cell-item>
              <m-cell-item
                v-if="form.status === 'CLOSED'"
                :label="$t('apply.title.closedReason')"
                :value="form.closedReason"
              ></m-cell-item>
              <m-cell-item
                :label="$t('apply.title.surname')"
                :value="form.surname"
              ></m-cell-item>
              <m-cell-item
                :label="$t('apply.title.givenName')"
                :value="form.givenName"
              ></m-cell-item>
              <m-cell-item
                :label="$t('apply.title.companyName')"
                :value="form.companyName"
              ></m-cell-item>
              <m-cell-item
                v-if="form.status === 'REMODIFY'"
                :label="$t('apply.title.reason')"
                :value="form.remodifyReason"
              ></m-cell-item>
              <m-cell-item
                :label="$t('apply.title.venueName')"
                :value="form.siteName"
              ></m-cell-item>
            </m-cell>
          </div>
          <div
            style="
              flex-direction: row;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            {{ getResultTip(form?.status, form?.companyType) }}
          </div>
        </m-folding-panel>
      </template>
    </m-form>
    <template slot="actions">
      <m-button
        type="primary"
        ghost
        size="large"
        @click="onPrevious()"
        class="mr-4"
        >{{ this.$t('Common.action.mainMenu') }}</m-button
      >
      <m-button
        type="primary"
        size="large"
        v-if="form.status === 'REMODIFY' && form.applicationType !== 'RFC'"
        @click="reissue()"
        >{{ this.$t('apply.button.reissue') }}</m-button
      >
      <m-button
        type="primary"
        size="large"
        @click="onDownload()"
        v-if="downloadStatus()"
        >{{ this.$t('Common.action.downloadnotification') }}</m-button
      >
    </template>
  </PageLayout>
</template>

<script>
import { ApplyAPI } from '@/api';
import PageLayout from '@/components/Layout/web/PageLayout.vue';
import { is_mobile, getCompanyType, downloadFile, getResultTip } from 'govmo-common/src/utils/utils';
import PageHeader from 'common/components/Layout/web/PageHeader.vue';
import { ExclamationCircleFilled } from '@ant-design/icons-vue';

export default {
  components: {
    PageLayout,
    PageHeader,
    ExclamationCircleFilled,
  },
  props: {
    formData: {
      type: Object,
    },
  },
  data() {
    return {
      form: null,
    };
  },
  methods: {
    is_mobile,
    getCompanyType,
    getResultTip,
    onPrevious() {
      this.$router.push('/');
    },
    downloadStatus() {
      let data = this.$route.params.formData
      if (
        data.status === 'PASSED' &&
        data.siteName &&
        data.staffNum > 0 &&
        data.siteAddress &&
        data.openDate &&
        data.businessHours
      ) {
        return true;
      } else {
        return false;
      }
    },
    reissue() {
      this.$router.push({
        name: 'apply',
        params: {
          ...this.form,
          isReissue: true,
          typeName:
            this.form.companyType === 'PERSONAL' ? 'business' : 'company',
        },
      });
    },
    async onDownload() {
      try {
        //下載憑單
        this.$showLoading();
        let filResult = await ApplyAPI.downloadAdvance(
          this.form.applicationNo,
          this.form.expire,
          this.form.signature
        );
        downloadFile(filResult, this.form.applicationNo);
      } catch (error) {
        this.$error(this.$t('ERROR_CODE_MESSAGE.NO_PDF'));
      } finally {
        this.$hideLoading();
      }
    },
  },
  async created() {
    console.log('====4', this.$route.params.formData);
    this.form = this.form ? this.form : { ...this.$route.params.formData };
  },
};
</script>
<style lang="scss" scoped>
</style>
